const ArmeniaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110782)">
      <path
        d="M40 19.9989C40 17.5525 39.56 15.209 38.756 13.0425L20 12.1729L1.24398 13.0424C0.440078 15.209 0 17.5525 0 19.9989C0 22.4454 0.440078 24.7889 1.24398 26.9554L20 27.825L38.756 26.9555C39.56 24.7889 40 22.4454 40 19.9989Z"
        fill="#0052B4"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#FF9811"
      />
      <path
        d="M1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110782">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ArmeniaSvg;
